<template>
<div id="fx">
	<div class="container" ref="container" v-if="!loading">
	</div>
</div>
</template>

<style scoped lang="sass">
.container
	position: fixed
	pointer-events: none
	left: 0%
	right: 0%
	top : 0%
	height: 100dvh
	bottom : 0%
	z-index: 20000
	contain: strict

@supports not (height: 100dvh)
	.chatevent
		height: 100vh
		
</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'fx',
	props: {
		
	},
	data : function(){
		return {
			loading : true
		}
	},
	computed: mapState({
		auth : state => state.auth,
		fx : state => state.fx
	}),

	watch : {
		fx : {
			immediate : true,
			handler : function(){
				console.log('this.fx', this.fx)
				this.make()
			}
		}
	},

	methods: {
		make(){

			if(!this.core.fx){
				this.$store.commit('FX')
			}

			if(!this.fx) return

			this.core.fx.prepare(() => {
				this.loading = false

				setTimeout(() => {

					if(!this.fx) return

					if (this.fx.infinity){

						if (this.core.infinityEffect){
							return 
						}

						console.log("INIF")

						this.core.infinityEffect = this.core.fx.infinityEffect(this.$refs.container, () => {
							this.$store.commit('FX')
							this.core.infinityEffect = null
						})

					}
					else{
						this.core.fx.effect(this.$refs.container, this.fx.name, this.fx.parameters, () => {
							this.$store.commit('FX')
						})
					}

					
				},50)
			})

			
		}
	},
}
</script>
